import React, {useEffect, useState} from 'react'
import UiInputText from "../components/Form/UiInputText";
import UiInputDate from "../components/Form/UiInputDate";
import Form from "../components/Form/Form";
import {useForm, FormProvider} from "react-hook-form";
import FormContainer from '../components/Form/FormContainer';
import Button from 'react-bootstrap/Button';
import UiInputSuggest from "../components/Form/UiInputSuggest";
import UiInputList from "../components/Form/UiInputList";
import UiInputMoney from "../components/Form/UiInputMoney";
import { get } from "../services/ApiService";

interface ContaPagar {
    id: number;
    tipo: string;
    descricao: string;
    valor_total: number;
    saldo_aberto: number;
    data_vencimento: string;
}

export default function PagamentoForm(props: any){
    const today = new Date().toISOString().split('T')[0];
    const methods = useForm({
        defaultValues: props.data || { meio: 'pix', data: today }
    });
    const { handleSubmit, watch, setValue } = methods;
    const [contasPagar, setContasPagar] = useState<ContaPagar[]>([]);

    const meioList = [
        { id: 'pix', title: 'PIX' },
        { id: 'dinheiro', title: 'Dinheiro' },
        { id: 'boleto', title: 'Boleto' },
        { id: 'transferencia', title: 'Transferência' },
        { id: 'cartao', title: 'Cartão' },
        { id: 'cheque', title: 'Cheque' },
        { id: 'debito_automatico', title: 'Débito Automático' },
        { id: 'outro', title: 'Outro' },
    ];

    const contrato = watch('contrato');

    useEffect(() => {
        if (contrato?.id) {
            get(`/?route=pagamento/form&action=contasPagarDisponiveis&contratoId=${contrato.id}`)
                .then((response: any) => {
                    if (response.data?.success) {
                        setContasPagar(response.data.data || []);
                    }
                });
        }
    }, [contrato?.id]);

    const contasPagarList = contasPagar.map(ap => ({
        id: ap.id,
        title: `#${ap.id} - ${ap.descricao} (Saldo: R$ ${Number(ap.saldo_aberto || 0).toFixed(2)})`
    }));

    return (
        <FormContainer size="lg" show={true} onHide={props.triggerClose}>
            <FormProvider {...methods}>
                <Form onSubmit={handleSubmit(props.triggerSubmit)} methods={methods}>
                    <FormContainer.Header onClose={props.triggerClose}>
                        <h5>{props.data?.id ? 'Editar Pagamento' : 'Novo Pagamento'}</h5>
                    </FormContainer.Header>
                    <FormContainer.Body>
                        <div className="row">
                            <div className="col-12">
                                <fieldset>
                                    <legend>Vinculação</legend>
                                    <div className="row">
                                        <UiInputSuggest size={4} router="contrato" idField="id" titleField="cli_nome" name="contrato" label="Contrato" required />
                                        <UiInputSuggest size={4} router="contaFinanceira" idField="id" titleField="nome" name="contaFinanceira" label="Conta Financeira" required />
                                        <UiInputList size={4} name="contaPagar" list={contasPagarList} idField="id" titleField="title" label="Conta a Pagar" />
                                    </div>
                                </fieldset>
                            </div>
                            <div className="col-12">
                                <fieldset>
                                    <legend>Dados do Pagamento</legend>
                                    <div className="row">
                                        <UiInputDate size={3} name="data" label="Data" dateFormat="dd/mm/yy" />
                                        <UiInputMoney size={3} name="valor" label="Valor" required />
                                        <UiInputList size={3} name="meio" list={meioList} idField="id" titleField="title" label="Meio" required />
                                        <UiInputText size={3} name="referencia" label="Referência" />
                                        <UiInputText size={12} name="descricao" label="Descrição" />
                                        <UiInputText size={12} name="observacoes" label="Observações" />
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    </FormContainer.Body>
                    <FormContainer.Footer>
                        <Button variant="secondary" onClick={props.triggerClose}>Fechar</Button>
                        <Button variant="primary" type="submit">Salvar</Button>
                    </FormContainer.Footer>
                </Form>
            </FormProvider>
        </FormContainer>
    )
}
